import { render, staticRenderFns } from "./clientItem.vue?vue&type=template&id=776e13fe&"
import script from "./clientItem.vue?vue&type=script&lang=js&"
export * from "./clientItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports